import { createBrowserHistory } from "history";

// 创建自定义 history 对象
export const history = createBrowserHistory();
